import React from 'react'
import Inner from '../component/Innerbanner'

function HatsPolosMore() {
    return (
        <div>
            <Inner name="Hats, Polos & More" title="Home   Hats, Polos & More " />
        </div>
    )
}

export default HatsPolosMore